module.exports = __webpack_public_path__ + "static/media/menu_icon_literally_report_normal.dfe2c1f4.png";